import { render, staticRenderFns } from "./mailling-list.vue?vue&type=template&id=08303c72&scoped=true"
import script from "./mailling-list.vue?vue&type=script&lang=js"
export * from "./mailling-list.vue?vue&type=script&lang=js"
import style0 from "./mailling-list.vue?vue&type=style&index=0&id=08303c72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08303c72",
  null
  
)

export default component.exports